module.exports = __webpack_public_path__ + "static/sec5-bg-cee6c2de3b12f224ce8e95a5ffd5af4c.jpg";